import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import { mediaUrl } from "../lib/api";

export function UserAvatar({ user, className = "", premium, ...props }) {
  const src = mediaUrl(user?.avatar_url);
  const name = user?.name || user?.username || "?";
  const isPrem = premium ?? user?.is_premium;
  const inner = (
    <Avatar className={className} {...props}>
      {src && <AvatarImage src={src} alt={name} />}
      <AvatarFallback className="bg-[#E50914] text-white font-semibold">
        {name.slice(0, 2).toUpperCase()}
      </AvatarFallback>
    </Avatar>
  );
  if (isPrem) {
    return <div className="premium-frame inline-flex" data-testid="premium-frame">{inner}</div>;
  }
  return inner;
}

export function VerifiedBadge({ size = 15, className = "" }) {
  return (
    <span data-testid="verified-badge" className={`inline-flex items-center text-[#1d9bf0] ${className}`} title="Onaylı Yayıncı">
      <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
        <path d="M12 1.5l2.6 1.9 3.2-.2 1 3 2.7 1.7-1 3 1 3-2.7 1.7-1 3-3.2-.2L12 22.5l-2.6-1.9-3.2.2-1-3L2.5 15l1-3-1-3 2.7-1.7 1-3 3.2.2L12 1.5z"/>
        <path d="M10.6 14.6l-2.2-2.2-1.4 1.4 3.6 3.6 6-6-1.4-1.4-4.6 4.6z" fill="#141414"/>
      </svg>
    </span>
  );
}

export function EfsaneBadge({ className = "" }) {
  return (
    <span className={`efsane-badge text-xs ${className}`} data-testid="efsane-badge">
      ✦ efsane
    </span>
  );
}
